var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","loading":_vm.loading,"title":"Make it Default"},on:{"click":function($event){return _vm.submit()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-star-four-points")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }